// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lumen5-icon--yA77T .right-shape--grZgH{position:relative;top:2px;left:-8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lumen5-icon": "lumen5-icon--yA77T",
	"right-shape": "right-shape--grZgH"
};
export default ___CSS_LOADER_EXPORT___;
